// // import { Alert, Box, Button, CircularProgress, Grid, Paper, Typography } from '@mui/material';
// // import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// // import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// // import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// // import { useAppSelector } from 'app/hooks';
// // import {
// //   CategoryScale,
// //   Chart as ChartJS,
// //   ChartOptions,
// //   Legend,
// //   LinearScale,
// //   LineElement,
// //   PointElement,
// //   Title,
// //   Tooltip
// // } from 'chart.js';
// // import dayjs, { Dayjs } from 'dayjs';
// // import React, { useEffect, useMemo, useState } from 'react';
// // import { Line } from 'react-chartjs-2';
// // import { FaArrowCircleDown, FaArrowCircleUp } from 'react-icons/fa';
// // import { useDispatch, useSelector } from 'react-redux';
// // import { useNavigate } from 'react-router-dom';
// // import type { DailyPricePoint } from 'slices/fundManagementInvestment/fundManagementConfigurationSlice';
// // import {
// //   getDailyUnitPriceAvg,
// //   selectDailyUnitPriceError,
// //   selectDailyUnitPriceLoading,
// //   selectGrowthUnitPrices,
// //   selectIncomeUnitPrices
// // } from 'slices/fundManagementInvestment/fundManagementConfigurationSlice';
// // import { AppDispatch } from 'store';

// // ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

// // const blackGrayPalette = {
// //   border: '1px solid rgba(255,255,255,0.1)',
// //   cardShadow: '0 8px 40px rgba(0,0,0,0.9)',
// //   subText: '#A6ABBF',
// //   accentIncome: '#3b82f6',
// //   accentGrowth: '#0ea5e9',
// //   buttonBg: 'linear-gradient(135deg, #2563eb 10%, #0284c7 90%)',
// //   buttonHover: 'linear-gradient(135deg, #1e40af 10%, #0369a1 90%)',
// //   buttonSellBg: 'linear-gradient(135deg, #ea580c 10%, #c2410c 90%)',
// //   buttonSellHover: 'linear-gradient(135deg, #b45309 10%, #7c2d12 90%)',
// //   paperBg: 'rgba(20, 22, 28, 0.95)'
// // };

// // const AnalyticsPlaceholder: React.FC = () => {
// //   const navigate = useNavigate();
// //   const dispatch = useDispatch<AppDispatch>();

// //   const selectedProjectId = useAppSelector((state) => state.homeTilesServices.selectedProjectId);

// //   const growthPrices = useSelector(selectGrowthUnitPrices);
// //   const incomePrices = useSelector(selectIncomeUnitPrices);
// //   const loading = useSelector(selectDailyUnitPriceLoading);
// //   const error = useSelector(selectDailyUnitPriceError);

// //   const [fromDate, setFromDate] = useState<Dayjs | null>(dayjs().subtract(29, 'day'));
// //   const [toDate, setToDate] = useState<Dayjs | null>(dayjs());

// //   // Fetch data when dates or project change
// //   useEffect(() => {
// //     if (!selectedProjectId || !fromDate || !toDate) return;

// //     const from = fromDate.format('YYYY-MM-DD');
// //     const to = toDate.format('YYYY-MM-DD');

// //     dispatch(
// //       getDailyUnitPriceAvg({
// //         groupId: selectedProjectId,
// //         serviceId: 'fundManagementInvestment',
// //         unitType: 'growthUnits',
// //         fromDate: from,
// //         toDate: to
// //       })
// //     );

// //     dispatch(
// //       getDailyUnitPriceAvg({
// //         groupId: selectedProjectId,
// //         serviceId: 'fundManagementInvestment',
// //         unitType: 'incomeUnits',
// //         fromDate: from,
// //         toDate: to
// //       })
// //     );
// //   }, [dispatch, selectedProjectId, fromDate, toDate]);

// //   // Process chart data
// //   const chartDataAndLabels = useMemo(() => {
// //     const dateMap = new Map<string, { growth?: number; income?: number }>();

// //     growthPrices.forEach((point: DailyPricePoint) => {
// //       if (point.source === 'no_data' || parseFloat(point.averageUnitPrice) <= 0) return;
// //       const price = parseFloat(point.averageUnitPrice);
// //       const entry = dateMap.get(point.date) || {};
// //       entry.growth = price;
// //       dateMap.set(point.date, entry);
// //     });

// //     incomePrices.forEach((point: DailyPricePoint) => {
// //       if (point.source === 'no_data' || parseFloat(point.averageUnitPrice) <= 0) return;
// //       const price = parseFloat(point.averageUnitPrice);
// //       const entry = dateMap.get(point.date) || {};
// //       entry.income = price;
// //       dateMap.set(point.date, entry);
// //     });

// //     const sortedDates = Array.from(dateMap.keys()).sort();
// //     const labels = sortedDates.map((date) =>
// //       new Date(date).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' })
// //     );

// //     const growthData = sortedDates.map((d) => dateMap.get(d)?.growth ?? null);
// //     const incomeData = sortedDates.map((d) => dateMap.get(d)?.income ?? null);

// //     const allPrices = [...growthPrices, ...incomePrices]
// //       .filter((p) => p.source !== 'no_data' && parseFloat(p.averageUnitPrice) > 0)
// //       .sort((a, b) => b.date.localeCompare(a.date));

// //     const latestPrice = allPrices[0]?.averageUnitPrice || '0.0000';

// //     return {
// //       labels,
// //       growthData,
// //       incomeData,
// //       latestPrice: parseFloat(latestPrice).toFixed(4)
// //     };
// //   }, [growthPrices, incomePrices]);

// //   const { labels, growthData, incomeData, latestPrice } = chartDataAndLabels;

// //   const data = {
// //     labels: labels.length > 0 ? labels : ['No Data'],
// //     datasets: [
// //       {
// //         label: 'Income Units',
// //         data: incomeData,
// //         borderColor: blackGrayPalette.accentIncome,
// //         backgroundColor: 'rgba(59,130,246,0.15)',
// //         fill: true,
// //         tension: 0.4,
// //         pointRadius: 4,
// //         pointHoverRadius: 7,
// //         borderWidth: 3
// //       },
// //       {
// //         label: 'Growth Units',
// //         data: growthData,
// //         borderColor: blackGrayPalette.accentGrowth,
// //         backgroundColor: 'rgba(14,165,233,0.15)',
// //         fill: true,
// //         tension: 0.4,
// //         pointRadius: 4,
// //         pointHoverRadius: 7,
// //         borderWidth: 3
// //       }
// //     ]
// //   };

// //   const options: ChartOptions<'line'> = {
// //     responsive: true,
// //     maintainAspectRatio: false,
// //     plugins: {
// //       legend: {
// //         position: 'top' as const,
// //         labels: { color: blackGrayPalette.subText, font: { size: 12 }, usePointStyle: true }
// //       },
// //       tooltip: {
// //         backgroundColor: 'rgba(20,20,30,0.95)',
// //         titleColor: '#fff',
// //         bodyColor: '#fff',
// //         cornerRadius: 8,
// //         callbacks: {
// //           label: (context) => {
// //             const value = context.parsed.y;
// //             if (value === null) return 'No data';
// //             return `${context.dataset.label}: $${value.toFixed(4)}`;
// //           }
// //         }
// //       }
// //     },
// //     scales: {
// //       x: {
// //         ticks: { color: blackGrayPalette.subText, font: { size: 10 } },
// //         grid: { color: 'rgba(255,255,255,0.05)' }
// //       },
// //       y: {
// //         ticks: {
// //           color: blackGrayPalette.subText,
// //           font: { size: 10 },
// //           callback: (value) => `$${Number(value).toFixed(2)}`
// //         },
// //         grid: { color: 'rgba(255,255,255,0.05)' }
// //       }
// //     }
// //   };

// //   return (
// //     <LocalizationProvider dateAdapter={AdapterDayjs}>
// //       <Paper
// //         elevation={0}
// //         sx={{
// //           borderRadius: 2,
// //           border: blackGrayPalette.border,
// //           boxShadow: blackGrayPalette.cardShadow,
// //           backgroundColor: blackGrayPalette.paperBg,
// //           p: { xs: 2, sm: 2.5, md: 3 },
// //           height: { xs: 'auto', sm: 480 },
// //           position: 'relative',
// //           overflow: 'hidden',
// //           display: 'flex',
// //           flexDirection: 'column'
// //         }}
// //       >
// //         {/* Title + Latest Price */}
// //         <Box
// //           sx={{
// //             mb: 3,
// //             display: 'flex',
// //             flexDirection: { xs: 'column', sm: 'row' },
// //             alignItems: 'center',
// //             justifyContent: 'space-between'
// //           }}
// //         >
// //           <Box>
// //             <Typography
// //               variant="subtitle1"
// //               sx={{
// //                 color: '#fff',
// //                 fontWeight: 600,
// //                 fontSize: { xs: '1rem', sm: '1.1rem', md: '1.2rem' }
// //               }}
// //             >
// //               Unit Price Performance
// //             </Typography>
// //             <Typography
// //               variant="caption"
// //               sx={{ color: blackGrayPalette.subText, display: 'block', mt: 0.5 }}
// //             >
// //               Latest Price: ${latestPrice}
// //             </Typography>
// //           </Box>

// //           {/* ULTRA PREMIUM DARK DATE PICKERS */}
// //           <Grid
// //             container
// //             spacing={2}
// //             sx={{ maxWidth: { xs: '100%', sm: 380 }, mt: { xs: 2, sm: 0 }, ml: { sm: 2 } }}
// //           >
// //             <Grid item xs={12} sm={6}>
// //               <DatePicker
// //                 label="From Date"
// //                 value={fromDate}
// //                 onChange={setFromDate}
// //                 maxDate={toDate || dayjs()}
// //                 slotProps={{
// //                   textField: {
// //                     size: 'small',
// //                     fullWidth: true,
// //                     sx: {
// //                       '& .MuiOutlinedInput-root': {
// //                         borderRadius: 1.5,
// //                         backgroundColor: '#1a1c20',
// //                         fontSize: { xs: '0.75rem', sm: '0.85rem' },
// //                         color: '#e5e7eb',
// //                         '& fieldset': { borderColor: 'rgba(255,255,255,0.15)' },
// //                         '&:hover fieldset': { borderColor: 'rgba(96,165,250,0.6)' },
// //                         '&.Mui-focused fieldset': { borderColor: '#3b82f6', borderWidth: 2 },
// //                         '& .MuiInputBase-input': {
// //                           color: '#e5e7eb',
// //                           backgroundColor: '#1a1c20',
// //                           '&::placeholder': { color: 'rgba(255,255,255,0.4)', opacity: 1 }
// //                         }
// //                       },
// //                       '& .MuiInputLabel-root': {
// //                         color: '#A6ABBF',
// //                         fontSize: { xs: '0.75rem', sm: '0.85rem' }
// //                       },
// //                       '& .MuiInputLabel-root.Mui-focused': { color: '#60a5fa' },
// //                       '& .MuiSvgIcon-root': { color: '#60a5fa', fontSize: { xs: 16, sm: 18 } }
// //                     }
// //                   },
// //                   popper: {
// //                     sx: {
// //                       '& .MuiPaper-root': {
// //                         backgroundColor: '#0f1115',
// //                         color: '#e5e7eb',
// //                         border: '1px solid rgba(255,255,255,0.15)',
// //                         borderRadius: 2,
// //                         boxShadow: '0 10px 40px rgba(0,0,0,0.8)',
// //                         overflow: 'hidden'
// //                       },
// //                       '& .MuiPickersDay-root': {
// //                         color: '#e5e7eb',
// //                         '&:hover': { backgroundColor: 'rgba(96,165,250,0.2)' },
// //                         '&.Mui-selected': {
// //                           backgroundColor: '#3b82f6 !important',
// //                           color: '#fff',
// //                           fontWeight: 600,
// //                           '&:hover': { backgroundColor: '#2563eb !important' }
// //                         },
// //                         '&.Mui-disabled': { color: '#555' }
// //                       },
// //                       '& .MuiPickersCalendarHeader-label, & .MuiTypography-root': {
// //                         color: '#e5e7eb'
// //                       },
// //                       '& .MuiDayCalendar-weekDayLabel': { color: '#60a5fa' }
// //                     }
// //                   }
// //                 }}
// //               />
// //             </Grid>

// //             <Grid item xs={12} sm={6}>
// //               <DatePicker
// //                 label="To Date"
// //                 value={toDate}
// //                 onChange={setToDate}
// //                 minDate={fromDate || undefined}
// //                 maxDate={dayjs()}
// //                 slotProps={{
// //                   textField: {
// //                     size: 'small',
// //                     fullWidth: true,
// //                     sx: {
// //                       '& .MuiOutlinedInput-root': {
// //                         borderRadius: 1.5,
// //                         backgroundColor: '#1a1c20',
// //                         fontSize: { xs: '0.75rem', sm: '0.85rem' },
// //                         color: '#e5e7eb',
// //                         '& fieldset': { borderColor: 'rgba(255,255,255,0.15)' },
// //                         '&:hover fieldset': { borderColor: 'rgba(96,165,250,0.6)' },
// //                         '&.Mui-focused fieldset': { borderColor: '#3b82f6', borderWidth: 2 },
// //                         '& .MuiInputBase-input': {
// //                           color: '#e5e7eb',
// //                           backgroundColor: '#1a1c20',
// //                           '&::placeholder': { color: 'rgba(255,255,255,0.4)', opacity: 1 }
// //                         }
// //                       },
// //                       '& .MuiInputLabel-root': {
// //                         color: '#A6ABBF',
// //                         fontSize: { xs: '0.75rem', sm: '0.85rem' }
// //                       },
// //                       '& .MuiInputLabel-root.Mui-focused': { color: '#60a5fa' },
// //                       '& .MuiSvgIcon-root': { color: '#60a5fa', fontSize: { xs: 16, sm: 18 } }
// //                     }
// //                   },
// //                   popper: {
// //                     sx: {
// //                       '& .MuiPaper-root': {
// //                         backgroundColor: '#0f1115',
// //                         color: '#e5e7eb',
// //                         border: '1px solid rgba(255,255,255,0.15)',
// //                         borderRadius: 2,
// //                         boxShadow: '0 10px 40px rgba(0,0,0,0.8)',
// //                         overflow: 'hidden'
// //                       },
// //                       '& .MuiPickersDay-root': {
// //                         color: '#e5e7eb',
// //                         '&:hover': { backgroundColor: 'rgba(96,165,250,0.2)' },
// //                         '&.Mui-selected': {
// //                           backgroundColor: '#3b82f6 !important',
// //                           color: '#fff',
// //                           fontWeight: 600
// //                         }
// //                       },
// //                       '& .MuiPickersCalendarHeader-label, & .MuiTypography-root': {
// //                         color: '#e5e7eb'
// //                       },
// //                       '& .MuiDayCalendar-weekDayLabel': { color: '#60a5fa' }
// //                     }
// //                   }
// //                 }}
// //               />
// //             </Grid>
// //           </Grid>
// //           <Box
// //             sx={{
// //               display: 'flex',
// //               gap: 1,
// //               flexWrap: 'wrap',
// //               justifyContent: 'flex-end'
// //             }}
// //           >
// //             <Button
// //               size="small"
// //               startIcon={<FaArrowCircleUp />}
// //               onClick={() => navigate('/fundManagementInvestment/purchase-units')}
// //               sx={{
// //                 textTransform: 'none',
// //                 fontWeight: 600,
// //                 bgcolor: blackGrayPalette.buttonBg,
// //                 color: 'white',
// //                 '&:hover': { bgcolor: blackGrayPalette.buttonHover },
// //                 minWidth: '80px',
// //                 mb: { xs: 1, sm: 0 }
// //               }}
// //             >
// //               Buy
// //             </Button>
// //             <Button
// //               size="small"
// //               startIcon={<FaArrowCircleDown />}
// //               onClick={() => navigate('/fundManagementInvestment/sell-units')}
// //               sx={{
// //                 textTransform: 'none',
// //                 fontWeight: 600,
// //                 bgcolor: blackGrayPalette.buttonSellBg,
// //                 color: 'white',
// //                 '&:hover': { bgcolor: blackGrayPalette.buttonSellHover },
// //                 minWidth: '80px'
// //               }}
// //             >
// //               Sell
// //             </Button>
// //           </Box>
// //         </Box>

// //         {/* Chart Area */}
// //         <Box sx={{ flexGrow: 1, position: 'relative', minHeight: { xs: 250, sm: 300 } }}>
// //           {loading ? (
// //             <Box
// //               sx={{
// //                 display: 'flex',
// //                 flexDirection: 'column',
// //                 alignItems: 'center',
// //                 justifyContent: 'center',
// //                 height: '100%'
// //               }}
// //             >
// //               <CircularProgress sx={{ color: '#3b82f6' }} />
// //               <Typography sx={{ mt: 2, color: blackGrayPalette.subText }}>
// //                 Loading price history...
// //               </Typography>
// //             </Box>
// //           ) : error ? (
// //             <Alert severity="error" sx={{ height: '100%', display: 'flex', alignItems: 'center' }}>
// //               Failed to load data: {error}
// //             </Alert>
// //           ) : labels.length === 0 ? (
// //             <Box
// //               sx={{
// //                 height: '100%',
// //                 display: 'flex',
// //                 alignItems: 'center',
// //                 justifyContent: 'center',
// //                 color: blackGrayPalette.subText
// //               }}
// //             >
// //               <Typography>No price data available for selected period</Typography>
// //             </Box>
// //           ) : (
// //             <Line data={data} options={options} />
// //           )}
// //         </Box>
// //       </Paper>
// //     </LocalizationProvider>
// //   );
// // };

// // export default AnalyticsPlaceholder;


// // src/components/fundManagement/mainDashboard/AnalyticsPlaceholder.tsx

// import { Alert, Box, Button, CircularProgress, Grid, Paper, Typography } from '@mui/material';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { useAppSelector } from 'app/hooks';
// import {
//   CategoryScale,
//   Chart as ChartJS,
//   ChartOptions,
//   Legend,
//   LinearScale,
//   LineElement,
//   PointElement,
//   Title,
//   Tooltip
// } from 'chart.js';
// import dayjs, { Dayjs } from 'dayjs';
// import React, { useEffect, useMemo, useState } from 'react';
// import { Line } from 'react-chartjs-2';
// import { FaArrowCircleDown, FaArrowCircleUp } from 'react-icons/fa';
// import { useDispatch, useSelector } from 'react-redux';
// import { useNavigate } from 'react-router-dom';

// // CORRECT TYPE — matches your backend
// import type { DailyPriceRecord } from 'slices/fundManagementInvestment/fundManagementConfigurationSlice';
// import {
//   getDailyUnitPriceAvg,
//   selectDailyUnitPriceError,
//   selectDailyUnitPriceLoading,
//   selectGrowthUnitPrices,
//   selectIncomeUnitPrices
// } from 'slices/fundManagementInvestment/fundManagementConfigurationSlice';
// import { AppDispatch } from 'store';

// ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

// const blackGrayPalette = {
//   border: '1px solid rgba(255,255,255,0.1)',
//   cardShadow: '0 8px 40px rgba(0,0,0,0.9)',
//   subText: '#A6ABBF',
//   accentIncome: '#3b82f6',
//   accentGrowth: '#0ea5e9',
//   buttonBg: 'linear-gradient(135deg, #2563eb 10%, #0284c7 90%)',
//   buttonHover: 'linear-gradient(135deg, #1e40af 10%, #0369a1 90%)',
//   buttonSellBg: 'linear-gradient(135deg, #ea580c 10%, #c2410c 90%)',
//   buttonSellHover: 'linear-gradient(135deg, #b45309 10%, #7c2d12 90%)',
//   paperBg: 'rgba(20, 22, 28, 0.95)'
// };

// const AnalyticsPlaceholder: React.FC = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch<AppDispatch>();

//   const selectedProjectId = useAppSelector((state) => state.homeTilesServices.selectedProjectId);

//   const growthPrices = useSelector(selectGrowthUnitPrices);   // DailyPriceRecord[]
//   const incomePrices = useSelector(selectIncomeUnitPrices);   // DailyPriceRecord[]
//   const loading = useSelector(selectDailyUnitPriceLoading);
//   const error = useSelector(selectDailyUnitPriceError);

//   const [fromDate, setFromDate] = useState<Dayjs | null>(dayjs().subtract(29, 'day'));
//   const [toDate, setToDate] = useState<Dayjs | null>(dayjs());

//   // Fetch data
//   useEffect(() => {
//     if (!selectedProjectId || !fromDate || !toDate) return;

//     const from = fromDate.format('YYYY-MM-DD');
//     const to = toDate.format('YYYY-MM-DD');

//     dispatch(
//       getDailyUnitPriceAvg({
//         groupId: selectedProjectId,
//         serviceId: 'fundManagementInvestment',
//         unitType: 'growthUnits',
//         fromDate: from,
//         toDate: to
//       })
//     );

//     dispatch(
//       getDailyUnitPriceAvg({
//         groupId: selectedProjectId,
//         serviceId: 'fundManagementInvestment',
//         unitType: 'incomeUnits',
//         fromDate: from,
//         toDate: to
//       })
//     );
//   }, [dispatch, selectedProjectId, fromDate, toDate]);

//   // Process chart data — 100% correct for your backend
//   const chartDataAndLabels = useMemo(() => {
//     const dateMap = new Map<string, { growth?: number; income?: number }>();

//     // Growth Units
//     growthPrices.forEach((point: DailyPriceRecord) => {
//       const price = parseFloat(point.unitPrice);
//       if (isNaN(price) || price <= 0) return;

//       const current = dateMap.get(point.date) || {};
//       current.growth = price;
//       dateMap.set(point.date, current);
//     });

//     // Income Units
//     incomePrices.forEach((point: DailyPriceRecord) => {
//       const price = parseFloat(point.unitPrice);
//       if (isNaN(price) || price <= 0) return;

//       const current = dateMap.get(point.date) || {};
//       current.income = price;
//       dateMap.set(point.date, current);
//     });

//     const sortedDates = Array.from(dateMap.keys()).sort();
//     const labels = sortedDates.map(date =>
//       new Date(date).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' })
//     );

//     const growthData = sortedDates.map(d => dateMap.get(d)?.growth ?? null);
//     const incomeData = sortedDates.map(d => dateMap.get(d)?.income ?? null);

//     // Find the absolute latest price (by date + time)
//     const allValidPrices = [...growthPrices, ...incomePrices]
//       .filter(p => {
//         const price = parseFloat(p.unitPrice);
//         return !isNaN(price) && price > 0;
//       })
//       .sort((a, b) => {
//         if (b.date !== a.date) return b.date.localeCompare(a.date);
//         return b.time.localeCompare(a.time); // latest time wins on same day
//       });

//     const latestPrice = allValidPrices[0]?.unitPrice || '0.0000';

//     return {
//       labels,
//       growthData,
//       incomeData,
//       latestPrice: parseFloat(latestPrice).toFixed(4)
//     };
//   }, [growthPrices, incomePrices]);

//   const { labels, growthData, incomeData, latestPrice } = chartDataAndLabels;

//   const data = {
//     labels: labels.length > 0 ? labels : ['No Data'],
//     datasets: [
//       {
//         label: 'Income Units',
//         data: incomeData,
//         borderColor: blackGrayPalette.accentIncome,
//         backgroundColor: 'rgba(59,130,246,0.15)',
//         fill: true,
//         tension: 0.4,
//         pointRadius: 4,
//         pointHoverRadius: 7,
//         borderWidth: 3
//       },
//       {
//         label: 'Growth Units',
//         data: growthData,
//         borderColor: blackGrayPalette.accentGrowth,
//         backgroundColor: 'rgba(14,165,233,0.15)',
//         fill: true,
//         tension: 0.4,
//         pointRadius: 4,
//         pointHoverRadius: 7,
//         borderWidth: 3
//       }
//     ]
//   };

//   const options: ChartOptions<'line'> = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: {
//         position: 'top' as const,
//         labels: { color: blackGrayPalette.subText, font: { size: 12 }, usePointStyle: true }
//       },
//       tooltip: {
//         backgroundColor: 'rgba(20,20,30,0.95)',
//         titleColor: '#fff',
//         bodyColor: '#fff',
//         cornerRadius: 8,
//         callbacks: {
//           label: (context) => {
//             const value = context.parsed.y;
//             if (value === null) return 'No data';
//             return `${context.dataset.label}: $${value.toFixed(4)}`;
//           }
//         }
//       }
//     },
//     scales: {
//       x: {
//         ticks: { color: blackGrayPalette.subText, font: { size: 10 } },
//         grid: { color: 'rgba(255,255,255,0.05)' }
//       },
//       y: {
//         ticks: {
//           color: blackGrayPalette.subText,
//           font: { size: 10 },
//           callback: (value) => `$${Number(value).toFixed(2)}`
//         },
//         grid: { color: 'rgba(255,255,255,0.05)' }
//       }
//     }
//   };

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <Paper
//         elevation={0}
//         sx={{
//           borderRadius: 2,
//           border: blackGrayPalette.border,
//           boxShadow: blackGrayPalette.cardShadow,
//           backgroundColor: blackGrayPalette.paperBg,
//           p: { xs: 2, sm: 2.5, md: 3 },
//           height: { xs: 'auto', sm: 480 },
//           position: 'relative',
//           overflow: 'hidden',
//           display: 'flex',
//           flexDirection: 'column'
//         }}
//       >
//         {/* Title + Latest Price */}
//         <Box
//           sx={{
//             mb: 3,
//             display: 'flex',
//             flexDirection: { xs: 'column', sm: 'row' },
//             alignItems: 'center',
//             justifyContent: 'space-between'
//           }}
//         >
//           <Box>
//             <Typography
//               variant="subtitle1"
//               sx={{
//                 color: '#fff',
//                 fontWeight: 600,
//                 fontSize: { xs: '1rem', sm: '1.1rem', md: '1.2rem' }
//               }}
//             >
//               Unit Price Performance
//             </Typography>
//             <Typography
//               variant="caption"
//               sx={{ color: blackGrayPalette.subText, display: 'block', mt: 0.5 }}
//             >
//               Latest Price: ${latestPrice}
//             </Typography>
//           </Box>

//           {/* Date Pickers */}
//           <Grid container spacing={2} sx={{ maxWidth: { xs: '100%', sm: 380 }, mt: { xs: 2, sm: 0 }, ml: { sm: 2 } }}>
//             <Grid item xs={12} sm={6}>
//               <DatePicker
//                 label="From Date"
//                 value={fromDate}
//                 onChange={setFromDate}
//                 maxDate={toDate || dayjs()}
//                 slotProps={{
//                   textField: {
//                     size: 'small',
//                     fullWidth: true,
//                     sx: {
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         backgroundColor: '#1a1c20',
//                         fontSize: { xs: '0.75rem', sm: '0.85rem' },
//                         color: '#e5e7eb',
//                         '& fieldset': { borderColor: 'rgba(255,255,255,0.15)' },
//                         '&:hover fieldset': { borderColor: 'rgba(96,165,250,0.6)' },
//                         '&.Mui-focused fieldset': { borderColor: '#3b82f6', borderWidth: 2 },
//                         '& .MuiInputBase-input': {
//                           color: '#e5e7eb',
//                           backgroundColor: '#1a1c20',
//                           '&::placeholder': { color: 'rgba(255,255,255,0.4)', opacity: 1 }
//                         }
//                       },
//                       '& .MuiInputLabel-root': {
//                         color: '#A6ABBF',
//                         fontSize: { xs: '0.75rem', sm: '0.85rem' }
//                       },
//                       '& .MuiInputLabel-root.Mui-focused': { color: '#60a5fa' },
//                       '& .MuiSvgIcon-root': { color: '#60a5fa', fontSize: { xs: 16, sm: 18 } }
//                     }
//                   },
//                   popper: {
//                     sx: {
//                       '& .MuiPaper-root': {
//                         backgroundColor: '#0f1115',
//                         color: '#e5e7eb',
//                         border: '1px solid rgba(255,255,255,0.15)',
//                         borderRadius: 2,
//                         boxShadow: '0 10px 40px rgba(0,0,0,0.8)'
//                       }
//                     }
//                   }
//                 }}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <DatePicker
//                 label="To Date"
//                 value={toDate}
//                 onChange={setToDate}
//                 minDate={fromDate || undefined}
//                 maxDate={dayjs()}
//                 slotProps={{
//                   textField: {
//                     size: 'small',
//                     fullWidth: true,
//                     sx: {
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 1.5,
//                         backgroundColor: '#1a1c20',
//                         fontSize: { xs: '0.75rem', sm: '0.85rem' },
//                         color: '#e5e7eb',
//                         '& fieldset': { borderColor: 'rgba(255,255,255,0.15)' },
//                         '&:hover fieldset': { borderColor: 'rgba(96,165,250,0.6)' },
//                         '&.Mui-focused fieldset': { borderColor: '#3b82f6', borderWidth: 2 },
//                         '& .MuiInputBase-input': {
//                           color: '#e5e7eb',
//                           backgroundColor: '#1a1c20',
//                           '&::placeholder': { color: 'rgba(255,255,255,0.4)', opacity: 1 }
//                         }
//                       },
//                       '& .MuiInputLabel-root': {
//                         color: '#A6ABBF',
//                         fontSize: { xs: '0.75rem', sm: '0.85rem' }
//                       },
//                       '& .MuiInputLabel-root.Mui-focused': { color: '#60a5fa' },
//                       '& .MuiSvgIcon-root': { color: '#60a5fa', fontSize: { xs: 16, sm: 18 } }
//                     }
//                   },
//                   popper: {
//                     sx: {
//                       '& .MuiPaper-root': {
//                         backgroundColor: '#0f1115',
//                         color: '#e5e7eb',
//                         border: '1px solid rgba(255,255,255,0.15)',
//                         borderRadius: 2,
//                         boxShadow: '0 10px 40px rgba(0,0,0,0.8)'
//                       }
//                     }
//                   }
//                 }}
//               />
//             </Grid>
//           </Grid>

//           {/* Buy / Sell Buttons */}
//           <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
//             <Button
//               size="small"
//               startIcon={<FaArrowCircleUp />}
//               onClick={() => navigate('/fundManagementInvestment/purchase-units')}
//               sx={{
//                 textTransform: 'none',
//                 fontWeight: 600,
//                 bgcolor: blackGrayPalette.buttonBg,
//                 color: 'white',
//                 '&:hover': { bgcolor: blackGrayPalette.buttonHover },
//                 minWidth: '80px',
//                 mb: { xs: 1, sm: 0 }
//               }}
//             >
//               Buy
//             </Button>
//             <Button
//               size="small"
//               startIcon={<FaArrowCircleDown />}
//               onClick={() => navigate('/fundManagementInvestment/sell-units')}
//               sx={{
//                 textTransform: 'none',
//                 fontWeight: 600,
//                 bgcolor: blackGrayPalette.buttonSellBg,
//                 color: 'white',
//                 '&:hover': { bgcolor: blackGrayPalette.buttonSellHover },
//                 minWidth: '80px'
//               }}
//             >
//               Sell
//             </Button>
//           </Box>
//         </Box>

//         {/* Chart Area */}
//         <Box sx={{ flexGrow: 1, position: 'relative', minHeight: { xs: 250, sm: 300 } }}>
//           {loading ? (
//             <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
//               <CircularProgress sx={{ color: '#3b82f6' }} />
//               <Typography sx={{ mt: 2, color: blackGrayPalette.subText }}>Loading price history...</Typography>
//             </Box>
//           ) : error ? (
//             <Alert severity="error" sx={{ height: '100%', display: 'flex', alignItems: 'center' }}>
//               Failed to load data: {error}
//             </Alert>
//           ) : labels.length === 0 ? (
//             <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: blackGrayPalette.subText }}>
//               <Typography>No price data available for selected period</Typography>
//             </Box>
//           ) : (
//             <Line data={data} options={options} />
//           )}
//         </Box>
//       </Paper>
//     </LocalizationProvider>
//   );
// };

// export default AnalyticsPlaceholder;

import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from 'app/hooks';
import dayjs, { Dayjs } from 'dayjs';
import { Line } from 'react-chartjs-2';
import { Box, Button, CircularProgress, Grid, Paper, Typography, Alert } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { FaArrowCircleDown, FaArrowCircleUp } from 'react-icons/fa';
import { ChartOptions } from 'chart.js';

import {
  getDailyUnitPriceAvg,
  selectDailyUnitPriceError,
  selectDailyUnitPriceLoading,
  selectGrowthUnitPrices,
  selectIncomeUnitPrices
} from 'slices/fundManagementInvestment/fundManagementConfigurationSlice';

type DailyPricePoint = {
  date: string;
  averageUnitPrice: string;
  source: string;
};

import { AppDispatch, RootState } from 'store'; // Adjust this import path if needed

const blackGrayPalette = {
  border: '1px solid rgba(255,255,255,0.1)',
  cardShadow: '0 8px 40px rgba(0,0,0,0.9)',
  subText: '#A6ABBF',
  accentIncome: '#3b82f6',
  accentGrowth: '#0ea5e9',
  buttonBg: 'linear-gradient(135deg, #2563eb 10%, #0284c7 90%)',
  buttonHover: 'linear-gradient(135deg, #1e40af 10%, #0369a1 90%)',
  buttonSellBg: 'linear-gradient(135deg, #ea580c 10%, #c2410c 90%)',
  buttonSellHover: 'linear-gradient(135deg, #b45309 10%, #7c2d12 90%)',
  paperBg: 'rgba(20, 22, 28, 0.95)'
};

const AnalyticsPlaceholder: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  const selectedProjectId = useAppSelector(state => state.homeTilesServices.selectedProjectId);
  const landingData = useAppSelector((state: any) => state.fundManagementInvestment?.landingData || []);
  const growthPrices = useSelector(selectGrowthUnitPrices);
  const incomePrices = useSelector(selectIncomeUnitPrices);
  const dailyPrices = [...(growthPrices || []), ...(incomePrices || [])];
  const loading = useSelector(selectDailyUnitPriceLoading);
  const error = useSelector(selectDailyUnitPriceError);

  const [fromDate, setFromDate] = useState<Dayjs | null>(dayjs().subtract(29, 'day'));
  const [toDate, setToDate] = useState<Dayjs | null>(dayjs());

  useEffect(() => {
    if (!selectedProjectId || !fromDate || !toDate) return;

    const today = new Date().toISOString().split('T')[0];
    const startDate = new Date();
    startDate.setMonth(startDate.getMonth() - 1);
    const fromDateString = startDate.toISOString().split('T')[0];

    dispatch(getDailyUnitPriceAvg({
      groupId: selectedProjectId,
      serviceId: 'fundManagementInvestment',
      unitType: 'growthUnits',
      fromDate: fromDateString,
      toDate: today
    }));

    dispatch(getDailyUnitPriceAvg({
      groupId: selectedProjectId,
      serviceId: 'fundManagementInvestment',
      unitType: 'incomeUnits',
      fromDate: fromDateString,
      toDate: today
    }));
  }, [dispatch, selectedProjectId]);

  // Process data: group by date and separate Growth/Income
  const chartDataAndLabels = useMemo(() => {
    const dateMap = new Map<string, { growth?: number; income?: number }>();

    dailyPrices.forEach((point: any) => {
      if (point.source === 'no_data') return;
      const price = parseFloat(point.averageUnitPrice);
      if (isNaN(price) || price <= 0) return;

      const entry = dateMap.get(point.date) || {};
      // Since we call two separate times, both results go into same array
      // We'll use a simple heuristic: latest non-zero price per date
      // In real data, Growth and Income may differ — here they’re often same
      entry.growth = price;
      entry.income = price; // fallback: show same if only one exists
      dateMap.set(point.date, entry);
    });

    const hasDailyData = dateMap.size > 0;

    if (!hasDailyData) {
      const incomeUnit = landingData.find((u: any) => u.unitType === 'incomeUnits');
      const growthUnit = landingData.find((u: any) => u.unitType === 'growthUnits');

      const incomeSeries = Array.isArray(incomeUnit?.unitPriceSeries) ? incomeUnit.unitPriceSeries : [];
      const growthSeries = Array.isArray(growthUnit?.unitPriceSeries) ? growthUnit.unitPriceSeries : [];

      const graphDateMap = new Map<string, { growth?: number; income?: number }>();

      incomeSeries.forEach((p: any) => {
        const date = p?.x;
        if (!date) return;
        const price = Number(p?.unitPrice ?? p?.averageUnitPrice ?? p?.y ?? 0);
        if (!Number.isFinite(price) || price <= 0) return;
        const entry = graphDateMap.get(date) || {};
        entry.income = price;
        graphDateMap.set(date, entry);
      });

      growthSeries.forEach((p: any) => {
        const date = p?.x;
        if (!date) return;
        const price = Number(p?.unitPrice ?? p?.averageUnitPrice ?? p?.y ?? 0);
        if (!Number.isFinite(price) || price <= 0) return;
        const entry = graphDateMap.get(date) || {};
        entry.growth = price;
        graphDateMap.set(date, entry);
      });

      const sortedGraphDates = Array.from(graphDateMap.keys()).sort();
      const labels = sortedGraphDates.map((date) =>
        new Date(date).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' })
      );
      const growthData = sortedGraphDates.map((date) => graphDateMap.get(date)?.growth ?? null);
      const incomeData = sortedGraphDates.map((date) => graphDateMap.get(date)?.income ?? null);

      const latestPriceValue =
        [...incomeSeries, ...growthSeries]
          .map((p: any) => Number(p?.unitPrice ?? p?.averageUnitPrice ?? p?.y ?? 0))
          .filter((v) => Number.isFinite(v) && v > 0)
          .slice(-1)[0] ?? 0;

      return {
        labels,
        growthData,
        incomeData,
        latestPrice: latestPriceValue > 0 ? latestPriceValue.toFixed(4) : '0.00'
      };
    }

    const sortedDates = Array.from(dateMap.keys()).sort();
    const labels = sortedDates.map(date =>
      new Date(date).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' })
    );
    const growthData = sortedDates.map(date => dateMap.get(date)?.growth ?? null);
    const incomeData = sortedDates.map(date => dateMap.get(date)?.income ?? null);
    const latestPrice = dailyPrices
      .filter((p: any) => p.source !== 'no_data' && parseFloat(p.unitPrice || p.averageUnitPrice) > 0)
      .sort((a: any, b: any) => b.date.localeCompare(a.date))[0]?.unitPrice || '0.00';

    return { labels, growthData, incomeData, latestPrice };
  }, [dailyPrices, landingData]);

  const { labels, growthData, incomeData, latestPrice } = chartDataAndLabels;

  const data = {
    labels: labels.length > 0 ? labels : ['No Data'],
    datasets: [
      {
        label: 'Income Units',
        data: incomeData,
        borderColor: blackGrayPalette.accentIncome,
        backgroundColor: 'rgba(59,130,246,0.15)',
        fill: true,
        tension: 0.4,
        pointRadius: 4,
        pointHoverRadius: 7,
        borderWidth: 3
      },
      {
        label: 'Growth Units',
        data: growthData,
        borderColor: blackGrayPalette.accentGrowth,
        backgroundColor: 'rgba(14,165,233,0.15)',
        fill: true,
        tension: 0.4,
        pointRadius: 4,
        pointHoverRadius: 7,
        borderWidth: 3
      }
    ]
  };

  const options: ChartOptions<'line'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        labels: { color: blackGrayPalette.subText, font: { size: 12 }, usePointStyle: true }
      },
      tooltip: {
        backgroundColor: 'rgba(20,20,30,0.95)',
        titleColor: '#fff',
        bodyColor: '#fff',
        cornerRadius: 8,
        callbacks: {
          label: (context) => {
            const value = context.parsed.y;
            if (value === null) return 'No data';
            return `${context.dataset.label}: $${value.toFixed(4)}`;
          }
        }
      }
    },
    scales: {
      x: {
        ticks: { color: blackGrayPalette.subText, font: { size: 10 } },
        grid: { color: 'rgba(255,255,255,0.05)' }
      },
      y: {
        ticks: {
          color: blackGrayPalette.subText,
          font: { size: 10 },
          callback: (value) => `$${Number(value).toFixed(2)}`
        },
        grid: { color: 'rgba(255,255,255,0.05)' }
      }
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Paper
        elevation={0}
        sx={{
          borderRadius: 2,
          border: blackGrayPalette.border,
          boxShadow: blackGrayPalette.cardShadow,
          backgroundColor: blackGrayPalette.paperBg,
          p: { xs: 2, sm: 2.5, md: 3 },
          height: { xs: 'auto', sm: 480 },
          position: 'relative',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Box
          sx={{
            mb: 3,
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          <Box>
            <Typography
              variant="subtitle1"
              sx={{
                color: '#fff',
                fontWeight: 600,
                fontSize: { xs: '1rem', sm: '1.1rem', md: '1.2rem' }
              }}
            >
              Unit Price Performance
            </Typography>
            <Typography
              variant="caption"
              sx={{ color: blackGrayPalette.subText, display: 'block', mt: 0.5 }}
            >
              Latest Price: ${latestPrice}
            </Typography>
          </Box>

          <Grid
            container
            spacing={2}
            sx={{ maxWidth: { xs: '100%', sm: 380 }, mt: { xs: 2, sm: 0 }, ml: { sm: 2 } }}
          >
            <Grid item xs={12} sm={6}>
              <DatePicker
                label="From Date"
                value={fromDate}
                onChange={setFromDate}
                maxDate={toDate || dayjs()}
                slotProps={{
                  textField: {
                    size: 'small',
                    fullWidth: true,
                    sx: {
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        backgroundColor: '#1a1c20',
                        fontSize: { xs: '0.75rem', sm: '0.85rem' },
                        color: '#e5e7eb',
                        '& fieldset': { borderColor: 'rgba(255,255,255,0.15)' },
                        '&:hover fieldset': { borderColor: 'rgba(96,165,250,0.6)' },
                        '&.Mui-focused fieldset': { borderColor: '#3b82f6', borderWidth: 2 },
                        '& .MuiInputBase-input': {
                          color: '#e5e7eb',
                          backgroundColor: '#1a1c20',
                          '&::placeholder': { color: 'rgba(255,255,255,0.4)', opacity: 1 }
                        }
                      },
                      '& .MuiInputLabel-root': {
                        color: '#A6ABBF',
                        fontSize: { xs: '0.75rem', sm: '0.85rem' }
                      },
                      '& .MuiInputLabel-root.Mui-focused': { color: '#60a5fa' },
                      '& .MuiSvgIcon-root': { color: '#60a5fa', fontSize: { xs: 16, sm: 18 } }
                    }
                  },
                  popper: {
                    sx: {
                      '& .MuiPaper-root': {
                        backgroundColor: '#0f1115',
                        color: '#e5e7eb',
                        border: '1px solid rgba(255,255,255,0.15)',
                        borderRadius: 2,
                        boxShadow: '0 10px 40px rgba(0,0,0,0.8)'
                      }
                    }
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <DatePicker
                label="To Date"
                value={toDate}
                onChange={setToDate}
                minDate={fromDate || undefined}
                maxDate={dayjs()}
                slotProps={{
                  textField: {
                    size: 'small',
                    fullWidth: true,
                    sx: {
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        backgroundColor: '#1a1c20',
                        fontSize: { xs: '0.75rem', sm: '0.85rem' },
                        color: '#e5e7eb',
                        '& fieldset': { borderColor: 'rgba(255,255,255,0.15)' },
                        '&:hover fieldset': { borderColor: 'rgba(96,165,250,0.6)' },
                        '&.Mui-focused fieldset': { borderColor: '#3b82f6', borderWidth: 2 },
                        '& .MuiInputBase-input': {
                          color: '#e5e7eb',
                          backgroundColor: '#1a1c20',
                          '&::placeholder': { color: 'rgba(255,255,255,0.4)', opacity: 1 }
                        }
                      },
                      '& .MuiInputLabel-root': {
                        color: '#A6ABBF',
                        fontSize: { xs: '0.75rem', sm: '0.85rem' }
                      },
                      '& .MuiInputLabel-root.Mui-focused': { color: '#60a5fa' },
                      '& .MuiSvgIcon-root': { color: '#60a5fa', fontSize: { xs: 16, sm: 18 } }
                    }
                  },
                  popper: {
                    sx: {
                      '& .MuiPaper-root': {
                        backgroundColor: '#0f1115',
                        color: '#e5e7eb',
                        border: '1px solid rgba(255,255,255,0.15)',
                        borderRadius: 2,
                        boxShadow: '0 10px 40px rgba(0,0,0,0.8)'
                      }
                    }
                  }
                }}
              />
            </Grid>
          </Grid>

          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
            <Button
              size="small"
              startIcon={<FaArrowCircleUp />}
              onClick={() => navigate('/fundManagementInvestment/purchase-units')}
              sx={{
                textTransform: 'none',
                fontWeight: 600,
                bgcolor: blackGrayPalette.buttonBg,
                color: 'white',
                '&:hover': { bgcolor: blackGrayPalette.buttonHover },
                minWidth: '80px',
                mb: { xs: 1, sm: 0 }
              }}
            >
              Buy
            </Button>
            <Button
              size="small"
              startIcon={<FaArrowCircleDown />}
              onClick={() => navigate('/fundManagementInvestment/sell-units')}
              sx={{
                textTransform: 'none',
                fontWeight: 600,
                bgcolor: blackGrayPalette.buttonSellBg,
                color: 'white',
                '&:hover': { bgcolor: blackGrayPalette.buttonSellHover },
                minWidth: '80px'
              }}
            >
              Sell
            </Button>
          </Box>
        </Box>

        <Box sx={{ flexGrow: 1, position: 'relative', minHeight: { xs: 250, sm: 300 } }}>
          {loading ? (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%'
              }}
            >
              <CircularProgress sx={{ color: '#3b82f6' }} />
              <Typography sx={{ mt: 2, color: blackGrayPalette.subText }}>
                Loading price history...
              </Typography>
            </Box>
          ) : error ? (
            <Alert severity="error" sx={{ height: '100%', display: 'flex', alignItems: 'center' }}>
              Failed to load data: {error}
            </Alert>
          ) : labels.length === 0 ? (
            <Box
              sx={{
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: blackGrayPalette.subText
              }}
            >
              <Typography>No price data available for selected period</Typography>
            </Box>
          ) : (
            <Line data={data} options={options} />
          )}
        </Box>
      </Paper>
    </LocalizationProvider>
  );
};

export default AnalyticsPlaceholder;
